import React from 'react';
import {
	Wrapper, Text
} from './lastMinuteStyles';
import PropTypes from 'prop-types';
import { getPrintableByDate, parseUTC } from 'core/utils';
import loadable from '@loadable/component';
const iconDims = { width: 75, height: 60 };
const LastMinuteGiftIcon = loadable(() => import('./LastMinuteGiftIcon'), {
	fallback: <div style={{ ...iconDims, marginRight: 5 }} />
});

const LastMinuteGift = ({ title }) => {
	const now = new Date();
	const pdfUrl = getPrintableByDate(now);
	return (
		<Wrapper>
			<LastMinuteGiftIcon {...iconDims} />
			<Text>
				<span>{title}</span>
				<br/>
				<a href={pdfUrl} target="_blank" rel="noreferrer">
					Download and print this note
				</a> to let them know their gift is on the way.
			</Text>
		</Wrapper>
	);
};

LastMinuteGift.propTypes = {
	title: PropTypes.string,
};

LastMinuteGift.defaultProps = {
	title: "Last Minute Gift? No worries.",
};

export default LastMinuteGift;
